import { React } from "react";
import { Button, Form, Input} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm, RightDrawerContainer } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import alertBlue from '../../../Assets/Icons/alertGreen.svg';
import { DisabledStyles } from "../../pageStyled";
import AlertRejectSummaryTableContainer from "./rejectAlert";

const { TextArea } = Input;

const RejectJobCardData = (props) => {
    return(<RightDrawerSidebar title="Reject Job Card" subtitle="" visible={props.visible} onClose={props.onCloseGrade}>
        <RightDrawerContainer>
            <div className="resetPassForm removePadLeft">
                <HaberForm>
                    <Form name="basic" autoComplete="off" className="haberLogin haberSignup" style={{ marginTop: '0' }}>
                        <div className="drawerField">
                            <div className="titleWithText">
                                <h5>Job Card Number</h5>
                                <p>An auto generated code to identify job card</p>
                            </div>
                            <Form.Item name="Job Card Number"
                                rules={[{ required: true }]} 
                            >
                                <DisabledStyles>
                                <Input defaultValue="ITC21082021"  disabled className="requestChangeValue" />
                                </DisabledStyles>
                            </Form.Item>
                        </div>

                        <div className="drawerField">
                            <div className="titleWithText">
                                <h5>Reason</h5>
                                <p>Please specify a reason for rejecting this Job Card</p>
                            </div>
                            <Form.Item name="Reason"
                                rules={[{ required: true }]} className=""
                            >
                               <TextArea
                      maxLength={100}
                      style={{ height: 90 }}
                      placeholder="Reason"
                    />
                            </Form.Item>
                        </div>
                        <div className="buttonFlex fixedBtm">
                            <Form.Item>
                                <Button htmlType="submit" className="themeBtn"><Iconmoon icon="wrong-file" size={16} color="#ffffff" />Reject Job Card</Button>
                            </Form.Item>
                        </div>
                    </Form>
                </HaberForm>
            </div>
            <AlertRejectSummaryTableContainer color="yellow btmFix" icon={alertBlue} msg="Once an Job Card is rejected, it can’t be approved or recovered later." />
        </RightDrawerContainer>
    </RightDrawerSidebar>
    );
}

export default RejectJobCardData;